export default __webpack_public_path__ + "static/lefafa_1_3-d7f9b12a7257ea0b33c9be87512f9b61.webp";